module.exports = __webpack_public_path__ + "img/DISCONNECTED.95deadee.svg";